import { StarRatingInput } from '@/components/review/StarRatingInput';
import { ReviewTextInput } from '@/components/review/ReviewTextInput';
import { PhotoUploadSection } from '@/components/review/PhotoUploadSection';
import { ReviewSubmitButton } from '@/components/review/ReviewSubmitButton';

interface ReviewFormProps {
  rating: number;
  comment: string;
  photos: File[];
  isAnonymous: boolean;
  isSubmitting: boolean;
  onRatingChange: (rating: number) => void;
  onCommentChange: (comment: string) => void;
  onPhotosChange: (photos: File[]) => void;
  onAnonymousToggle: (anonymous: boolean) => void;
  onSubmit: () => void;
  className?: string;
}

export function ReviewForm({ 
  rating,
  comment,
  photos,
  isAnonymous,
  isSubmitting,
  onRatingChange,
  onCommentChange,
  onPhotosChange,
  onAnonymousToggle,
  onSubmit,
  className = '' 
}: ReviewFormProps) {
  
  return (
    <div className={`space-y-8 ${className}`}>
      {/* 별점 입력 */}
      <div className="text-center">
        <h3 className="text-[18px] font-semibold text-[#222222] mb-4">
          평점을 선택해주세요
        </h3>
        <StarRatingInput
          rating={rating}
          onRatingChange={onRatingChange}
        />
        <p className="text-[14px] text-gray-500 mt-2">
          {rating === 5 ? '매우 만족' :
           rating === 4 ? '만족' :
           rating === 3 ? '보통' :
           rating === 2 ? '불만족' : '매우 불만족'}
        </p>
      </div>

      {/* 리뷰 텍스트 입력 */}
      <div>
        <h3 className="text-[18px] font-semibold text-[#222222] mb-4">
          리뷰를 작성해주세요
        </h3>
        <ReviewTextInput
          value={comment}
          onChange={onCommentChange}
          placeholder="음식의 맛, 양, 포장 상태 등에 대해 자세히 알려주세요.
다른 고객들에게 도움이 되는 솔직한 후기를 남겨주시면 감사하겠습니다."
          maxLength={500}
        />
      </div>

      {/* 사진 업로드 */}
      <div>
        <h3 className="text-[18px] font-semibold text-[#222222] mb-4">
          사진 첨부 (선택)
        </h3>
        <PhotoUploadSection
          photos={photos}
          onPhotosChange={onPhotosChange}
          maxPhotos={3}
        />
        <p className="text-[12px] text-gray-500 mt-2">
          최대 3장까지 업로드 가능합니다
        </p>
      </div>

      {/* 익명 리뷰 옵션 */}
      <div className="bg-gray-50 border border-gray-200 rounded-lg p-4">
        <label className="flex items-center cursor-pointer">
          <input
            type="checkbox"
            checked={isAnonymous}
            onChange={(e) => onAnonymousToggle(e.target.checked)}
            className="w-4 h-4 text-green-600 border-gray-300 rounded focus:ring-green-500 focus:ring-2"
          />
          <span className="ml-3 text-[14px] text-[#222222]">
            익명으로 리뷰 작성하기
          </span>
        </label>
        <p className="text-[12px] text-gray-500 ml-7 mt-1">
          체크하시면 닉네임 대신 '익명'으로 표시됩니다
        </p>
      </div>

      {/* 제출 버튼 */}
      <div className="pt-4">
        <ReviewSubmitButton
          onSubmit={async () => onSubmit()}
          isValid={!!comment.trim()}
          disabled={!comment.trim() || isSubmitting}
        />
      </div>
    </div>
  );
}